import React from "react";

const About = () => {
  return (
    <div>
      <h2> about this app</h2>
      <p> app about github users finder </p>
      <h3> eng osama mohamed </h3>
      <small>version 1.0.0</small>
    </div>
  );
};

export default About;
